import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";
import { SelectItem } from "../../../models/SelectItem";
import { MerchantBaseRequest, MerchantAccessStatusModel, MerchantMtlsAccessRequest, MerchantApiAccessResponseModel, MerchantOidcRequest } from "../../../models/MerchantModel";


class ClientApiService {
    path: string = "client";
    baseApiUrl = process.env.REACT_APP_AUTH_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;

    GetMerchantAccess = async (model:MerchantBaseRequest): Promise<Result<MerchantAccessStatusModel>> => await httpService.post<MerchantAccessStatusModel>(`/${this.path}/merchant-access`,model, { baseURL: this.baseApiUrl });
    AddMerchantPortalAccess = async (model: MerchantBaseRequest): Promise<Result<unknown>> => await httpService.post<unknown>(`/${this.path}/merchant-portal-access`, model, { baseURL: this.baseApiUrl });
    RemoveMerchantPortalAccess = async (merchantId: number): Promise<Result<unknown>> => await httpService.delete<unknown>(`${this.baseApiUrl}/${this.path}/merchant-portal-access/${merchantId}`);

     AddMerchantOidcAccess = async (model: MerchantOidcRequest): Promise<Result<unknown>> => await httpService.post<unknown>(`/${this.path}/oidc-access`, model, { baseURL: this.baseApiUrl });

    AddMerchantApiAccess = async (model: MerchantMtlsAccessRequest): Promise<Result<MerchantApiAccessResponseModel>> => await httpService.post<MerchantApiAccessResponseModel>(`/${this.path}/api-access`, model, { baseURL: this.baseApiUrl });

    RemoveMerchantApiAccess = async (merchantId: number): Promise<Result<unknown>> => await httpService.delete<unknown>(`${this.baseApiUrl}/${this.path}/api-access/${merchantId}`);

    RemoveMerchantOidcAccess = async (merchantId: number): Promise<Result<unknown>> => await httpService.delete<unknown>(`${this.baseApiUrl}/${this.path}/oidc-access/${merchantId}`);

    getClients = async (): Promise<Result<SelectItem[]>> => await httpService.get<SelectItem[]>(`/${this.path}/clients`);
}

const clientApiService = new ClientApiService();

export { clientApiService };
